var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToogleMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 18.118,
    viewBox: "0 0 28 18.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 28,
    height: 18.118,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 18.118,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 15.5L17 15.5V13L0.75 13L0.75 15.5ZM0.75 9.25H13.25V6.75L0.75 6.75L0.75 9.25ZM0.75 0.5L0.75 3L17 3V0.5L0.75 0.5ZM23.25 12.4875L18.775 8L23.25 3.5125L21.4875 1.75L15.2375 8L21.4875 14.25L23.25 12.4875Z",
    fill: "#33CC99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToogleMenu);
export default __webpack_public_path__ + "static/media/toogle_menu.e749992bcac8f051632758c5d975820f.svg";
export { ForwardRef as ReactComponent };